import React, { useCallback } from 'react';
import { View, Text } from 'react-native';

import { getUserName } from '../../../../common/utils/user/getUserName';
import { valueExists } from '../../../../common/utils/utils';

import { Button, TypographyHeading, TypographyParagraph } from '../../../components';
import VehicleSelector from '../../../components/selector/VehicleSelector';
import useServiceRunVehicleUpdate from '../useServiceRunVehicleUpdate';



const ServiceRunVehicleDetail = ({
	servicerun,
	styles,
	setShowDialogOpen,
	showConfirmButton,
	onUpdated,
	adminTraining = false,
	disableActions = false,
}) => {

	const closeDialogAfterUpdate = useCallback(() => {
		if (setShowDialogOpen) {
			setShowDialogOpen(false);
		}
		if (onUpdated) {
			onUpdated();
		}
	}, [onUpdated, setShowDialogOpen]);

	const { selectVehicle: modifyServiceRun, confirmVehicle, loading } = useServiceRunVehicleUpdate({
		serviceRunId: servicerun?.id,
		adminTraining,
		disableActions,
		onUpdated: closeDialogAfterUpdate,
	});

	return (
		<>
			<Text style={{ ...styles.headerText, marginTop: 8 }}>Driver and vehicle</Text>
			<View style={{ ...styles.detailView, flexDirection: 'row' }}>
				<View style={styles.leftItemWidth}>
					<TypographyHeading
						style={{ marginTop: 0 }}
						subheadingSmallSubtle={true}
						label="ASSIGNED DRIVER"
					/>
					<TypographyParagraph
						text={servicerun.driver && getUserName(servicerun.driver)}
					/>
				</View>
				<View style={styles.secondButton}>
					<TypographyHeading
						style={{ marginTop: 0 }}
						subheadingSmallSubtle={true}
						label="VEHICLE"
					/>
					<View style={styles.leftItemWidth}>
						<VehicleSelector
							vehicleName={getVehicleText(servicerun.vehicle)}
							initialFilter={{ isExcludedFromServiceRuns: false }}
							onChange={disableActions ? undefined : modifyServiceRun}
							customButton={({ onPress, label }) => {
								return (
									<TypographyParagraph
										onPress={disableActions ? undefined : onPress}
										style={{ fontSize: 14, color: styles.headerText.color }}
										href={!disableActions}
										disabled={disableActions}
										text={label}
									/>
								);
							}}
						/>
					</View>
				</View>
			</View>
			{
				showConfirmButton && Boolean(servicerun.vehicle?.id) && (
					<Button
						label={`Confirm ${getVehicleText(servicerun.vehicle)}`}
						onPress={confirmVehicle}
						disabled={disableActions || loading}
						loading={loading}
						style={{ marginTop: 16 }}
					/>
				)
			}
		</>
	);
};

export function getVehicleText (vehicle) {
	if (!valueExists(vehicle)) {
		return 'No vehicle selected';
	}
	else if (vehicle.name && vehicle.registration) {
		// Some vehicle names already carry the rego, e.g. "LDV G10+ (888733)";
		// adding it again showed "LDV G10+ (888733) (888733)".
		return vehicle.name.toLowerCase().includes(`(${vehicle.registration.trim().toLowerCase()})`)
			? vehicle.name
			: `${vehicle.name} (${vehicle.registration})`;
	}
	else if (vehicle.name) {
		return vehicle.name;
	}
	else if (vehicle.registration) {
		return vehicle.registration;
	}
	else {
		return 'Un-named vehicle';
	}
}

export default ServiceRunVehicleDetail;
